var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1296 13.8451C13.0538 13.8343 12.9563 13.8343 12.8696 13.8451C10.963 13.7801 9.44629 12.2201 9.44629 10.3026C9.44629 8.34177 11.028 6.74927 12.9996 6.74927C14.9605 6.74927 16.553 8.34177 16.553 10.3026C16.5421 12.2201 15.0363 13.7801 13.1296 13.8451Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3016 20.9949C18.3732 22.7608 15.8166 23.8333 12.9999 23.8333C10.1832 23.8333 7.62658 22.7608 5.69824 20.9949C5.80658 19.9766 6.45658 18.9799 7.61574 18.1999C10.5841 16.2283 15.4374 16.2283 18.3841 18.1999C19.5432 18.9799 20.1932 19.9766 20.3016 20.9949Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 23.8334C18.9834 23.8334 23.8337 18.9832 23.8337 13.0001C23.8337 7.017 18.9834 2.16675 13.0003 2.16675C7.01724 2.16675 2.16699 7.017 2.16699 13.0001C2.16699 18.9832 7.01724 23.8334 13.0003 23.8334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.69c6a84a9d9497084d3e5977a96a06b5.svg";
export { ForwardRef as ReactComponent };